import { Component } from '@angular/core';

@Component({
  selector: 'hmt-advanced-text-area',
  templateUrl: './advanced-text-area.component.html',
  standalone: false,
  styleUrls: ['./advanced-text-area.component.scss']
})
export class AdvancedTextAreaComponent {
  content: string = '';
  attachments: File[] = [];

  format(cmd: string) {
    document.execCommand(cmd, false);
  }

  onInput(html: string) {
    this.content = html;
  }

  onAttach(event: any) {
    this.attachments.push(event.target.files[0]);
    console.log("Attachments:", this.attachments);
  }

  clear(editor: HTMLElement) {
    editor.innerHTML = "";
    this.content = "";
  }

  send() {
    console.log("Message:", this.content);
  }
}
